// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3gR1y","selects":"Documents_selects__2dLzr"};